export const chat_page_limit = 20;
export const message_page_limit = 50;
export const backend_source = "backend";
export const local_source = "local";
